import { Component, ViewChild, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';

import { Stylist } from '../../models/stylist/stylist.model';
import { Salon } from '../../models/salon/salon.model';
import { UserService } from '../../services/user.service';
import { StylistService } from '../../services/stylist.service';
import { SalonService } from '../../services/salon.service';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
import { switchMap } from 'rxjs/operators';

import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { Router } from '@angular/router';
import { QuillModule } from 'ngx-quill';
@Component({
  selector: 'smr-booking-settings',
  templateUrl: './booking-settings.page.html',
  styleUrls: ['./booking-settings.page.scss'],
})
export class BookingSettingsPage {
  // @ViewChild(Content, { static: false }) content: Content;

  @ViewChild(StylistPickerComponent, { static: false })
  stylistPickerComponent: StylistPickerComponent;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public submitted: boolean;

  public savingInProgress: boolean;

  public stylistID: number;

  public stylist: Stylist;

  public readOnlyStylistPicker: boolean;

  public bookingSettingsForm: UntypedFormGroup;

  public allowBookingsUntil: UntypedFormControl;

  public bookingHorizon: UntypedFormControl;

  public sendAppointmentReminderBefore: UntypedFormControl;

  public bookingInterval: UntypedFormControl;

  public isRebook: UntypedFormControl;

  public suggestRebookingBeforeCheckout: UntypedFormControl;

  public confirmApptsManually: UntypedFormControl;

  public cc: UntypedFormControl;

  public letClientsRegister: UntypedFormControl;

  public letClientsCancel: UntypedFormControl;

  public bookingIntro: UntypedFormControl;

  public cancellationPolicy: UntypedFormControl;

  public hideDurations: UntypedFormControl;

  public waitingList: UntypedFormControl;

  public allowCancellationUntil: UntypedFormControl;

  public letClientsUseFBLogin: UntypedFormControl;

  public sameCancellationPolicyForAllStaff: UntypedFormControl;

  public allowBookingSlots: List<{ text: string; value: string }>;

  public allowCancellationUntilSlots: List<{ text: string; value: string }>;

  public bookingHorizonSlots: List<{ text: string; value: string }>;

  public sendReminderSlots: List<{ text: string; value: number }>;

  public bookingIntervalSlots: List<{ text: string; value: number }>;

  public cancellationPolicySlots: List<{ text: string; value: number }>;

  public config: QuillModule = {
    toolbar: [
      'bold',
      'italic',
      'underline',
      'strike',

      'divider',

      { list: 'ordered' },
      { list: 'bullet' },

      'divider',

      { indent: '-1' },
      { indent: '+1' },
      { align: [] },

      'divider',

      // { 'color': [] }, { 'background': [] },

      'clean',

      'divider',

      'link',
    ],
  };

  public ckEditorContent: string;
  public siteUrl: string;

  constructor(
    public userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private alertCtrl: AlertController,
    private stylistService: StylistService,
    private salonService: SalonService,
    private toastController: ToastController,
    private readonly alertService: AlertService,
    private loadingCtrl: LoadingController,
    private readonly toastService: ToastService,
    private router: Router
  ) {
    this.isLoading = true;
    this.submitted = false;
    this.savingInProgress = false;
    this.allowBookingsUntil = new UntypedFormControl('');
    this.bookingHorizon = new UntypedFormControl('');
    this.sendAppointmentReminderBefore = new UntypedFormControl('');
    this.bookingInterval = new UntypedFormControl('');
    this.isRebook = new UntypedFormControl('');
    this.suggestRebookingBeforeCheckout = new UntypedFormControl('');
    this.confirmApptsManually = new UntypedFormControl('');
    this.cc = new UntypedFormControl('');
    this.letClientsRegister = new UntypedFormControl('');
    this.letClientsCancel = new UntypedFormControl('');
    this.bookingIntro = new UntypedFormControl('');
    this.cancellationPolicy = new UntypedFormControl(
      '',
      Validators.maxLength(750)
    );
    this.sameCancellationPolicyForAllStaff = new UntypedFormControl(
      this.userService.getSalon().sameCancellationPolicyForAllStaff !==
        undefined
        ? this.userService.getSalon().sameCancellationPolicyForAllStaff
        : 0,
      Validators.required
    );
    this.hideDurations = new UntypedFormControl('');
    this.waitingList = new UntypedFormControl('');
    this.allowCancellationUntil = new UntypedFormControl('');
    this.letClientsUseFBLogin = new UntypedFormControl('');

    this.bookingSettingsForm = this.formBuilder.group({
      allowBookingsUntil: this.allowBookingsUntil,
      bookingHorizon: this.bookingHorizon,
      sendAppointmentReminderBefore: this.sendAppointmentReminderBefore,
      bookingInterval: this.bookingInterval,
      isRebook: this.isRebook,
      suggestRebookingBeforeCheckout: this.suggestRebookingBeforeCheckout,
      confirmApptsManually: this.confirmApptsManually,
      cc: this.cc,
      letClientsRegister: this.letClientsRegister,
      letClientsCancel: this.letClientsCancel,
      bookingIntro: this.bookingIntro,
      cancellationPolicy: this.cancellationPolicy,
      sameCancellationPolicyForAllStaff: this.sameCancellationPolicyForAllStaff,
      hideDurations: this.hideDurations,
      waitingList: this.waitingList,
      allowCancellationUntil: this.allowCancellationUntil,
      letClientsUseFBLogin: this.letClientsUseFBLogin,
    });

    this.allowBookingSlots = List([]);
    this.allowCancellationUntilSlots = List([]);
    this.bookingHorizonSlots = List([]);
    this.sendReminderSlots = List([]);
    this.cancellationPolicySlots = List([
      { text: 'Same for whole salon', value: 1 },
      { text: 'Each staff member can customize', value: 0 },
    ]);

    for (let i = 0; i <= 365; i++) {
      if (
        i == 18 ||
        i == 24 ||
        i == 36 ||
        i == 48 ||
        i == 72 ||
        (!(i > 12 && i <= 23) && i < 24)
      ) {
        this.allowBookingSlots = this.allowBookingSlots.push({
          text: i + ' hr' + (i > 1 ? 's' : '') + ' before',
          value: i + '',
        });

        this.allowCancellationUntilSlots =
          this.allowCancellationUntilSlots.push({
            text: i + ' hr' + (i > 1 ? 's' : '') + ' before',
            value: i.toString(),
          });
      }

      this.bookingHorizonSlots = this.bookingHorizonSlots.push({
        text: i + ' day' + (i > 1 ? 's' : '') + ' out',
        value: i + '',
      });

      if (i <= 23) {
        this.sendReminderSlots = this.sendReminderSlots.push({
          text: i + ' hr' + (i > 1 ? 's' : ''),
          value: i,
        });
      } else if (i == 24 || i == 48 || i == 72) {
        this.sendReminderSlots = this.sendReminderSlots.push({
          text: i / 24 + ' day' + (i >= 48 ? 's' : ''),
          value: i,
        });
      }
    }

    this.bookingIntervalSlots = List.of(
      {
        text: '15min',
        value: 15,
      },
      {
        text: '30min',
        value: 30,
      },
      {
        text: '45min',
        value: 45,
      },
      {
        text: '1hr',
        value: 60,
      },
      {
        text: '1hr 15min',
        value: 75,
      },
      {
        text: '1hr 30min',
        value: 90,
      },
      {
        text: '1hr 45min',
        value: 105,
      },
      {
        text: '2hr',
        value: 120,
      },
      {
        text: '2hr 15min',
        value: 135,
      },
      {
        text: '2hr 30min',
        value: 150,
      },
      {
        text: '2hr 45min',
        value: 165,
      },
      {
        text: '3hr',
        value: 180,
      },
      {
        text: '3hr 15min',
        value: 195,
      },
      {
        text: '3hr 30min',
        value: 210,
      },
      {
        text: '3hr 45min',
        value: 225,
      },
      {
        text: '4hr',
        value: 240,
      }
    );

    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (user.isAdministrator() || user.getViewAllCalendars() === 1) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
      const salonSubDomain = this.userService.getSalon().getSubDomain();
      if (salonSubDomain && salonSubDomain.length > 0) {
        this.siteUrl = `https://${salonSubDomain}.salonmonster.com`;
      }
    }
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
      //this.content.resize();
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public onStylistSelect(stylist: Stylist) {
    this.isLoading = true;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;
      this.bookingSettingsForm.reset();
      this.allowBookingsUntil.setValue(stylist.getAllowBookingsUntil());
      this.bookingHorizon.setValue(stylist.getBookingHorizon());
      this.sendAppointmentReminderBefore.setValue(
        stylist.getSendAppointmentReminderBefore()
      );
      this.bookingInterval.setValue(stylist.getBookingInterval());
      this.isRebook.setValue(stylist.getIsRebook() === 1 ? true : false);
      this.suggestRebookingBeforeCheckout.setValue(
        stylist.getsuggestRebookingBeforeCheckout() === 1 ? true : false
      );
      this.confirmApptsManually.setValue(
        stylist.getConfirmApptsManually() === 1 ? true : false
      );
      this.cc.setValue(stylist.getCc() === 1 ? true : false);
      this.letClientsRegister.setValue(
        stylist.getLetClientsRegister() === 1 ? true : false
      );
      this.letClientsCancel.setValue(
        stylist.getLetClientsCancel() === 1 ? true : false
      );
      this.bookingIntro.setValue(stylist.getBookingIntro());
      this.ckEditorContent = stylist.getBookingIntro();
      this.hideDurations.setValue(stylist.getHideDurations() === 1);
      this.waitingList.setValue(stylist.waitingList === 1);
      this.allowCancellationUntil.setValue(stylist.allowCancellationUntil.toString());
      this.letClientsUseFBLogin.setValue(stylist.letClientsUseFBLogin === 1);

      let cancellationPolicy: string = '';

      if (this.userService.getSalon().sameCancellationPolicyForAllStaff === 1) {
        cancellationPolicy = this.userService
          .getSalon()
          .getCancellationPolicy();
      } else {
        cancellationPolicy = stylist.cancellationPolicy;
      }

      this.cancellationPolicy.setValue(cancellationPolicy);
      this.sameCancellationPolicyForAllStaff.setValue(
        this.userService.getSalon().sameCancellationPolicyForAllStaff !==
          undefined
          ? this.userService.getSalon().sameCancellationPolicyForAllStaff
          : 0
      );
    }

    this.isLoading = false;
  }

  public async onBookingSettingsSave() {
    this.submitted = true;

    if (this.bookingSettingsForm.valid === false) {
      return;
    }

    let salon: Salon = this.userService.getSalon();
    salon = salon.setSameCancellationPolicyForAllStaff(
      this.sameCancellationPolicyForAllStaff.value
    );

    this.stylist = this.stylist.setAllowBookingsUntil(
      this.allowBookingsUntil.value
    );
    this.stylist = this.stylist.setBookingHorizon(this.bookingHorizon.value);
    this.stylist = this.stylist.setSendAppointmentReminderBefore(
      this.sendAppointmentReminderBefore.value
    );
    this.stylist = this.stylist.setBookingInterval(this.bookingInterval.value);
    this.stylist = this.stylist.setIsRebook(this.isRebook.value ? 1 : 0);
    this.stylist = this.stylist.setsuggestRebookingBeforeCheckout(
      this.suggestRebookingBeforeCheckout.value ? 1 : 0
    );
    this.stylist = this.stylist.setConfirmApptsManually(
      this.confirmApptsManually.value ? 1 : 0
    );
    this.stylist = this.stylist.setCc(this.cc.value ? 1 : 0);
    this.stylist = this.stylist.setLetClientsRegister(
      this.letClientsRegister.value ? 1 : 0
    );
    this.stylist = this.stylist.setLetClientsCancel(
      this.letClientsCancel.value ? 1 : 0
    );
    this.stylist = this.stylist.setBookingIntro(this.bookingIntro.value);
    this.stylist = this.stylist.setHideDurations(
      this.hideDurations.value ? 1 : 0
    );
    this.stylist = this.stylist.setWaitingList(this.waitingList.value ? 1 : 0);
    this.stylist = this.stylist.setallowCancellationUntil(
      this.allowCancellationUntil.value
    );
    this.stylist = this.stylist.setLetClientsUseFBLogin(
      this.letClientsUseFBLogin.value ? 1 : 0
    );

    if (this.sameCancellationPolicyForAllStaff.value === 0) {
      this.stylist = this.stylist.setCancellationPolicy(
        this.cancellationPolicy.value
      );
    } else {
      salon = salon.setCancellationPolicy(this.cancellationPolicy.value);
    }

    this.savingInProgress = true;

    const loader = await this.loadingCtrl.create({
        spinner: 'crescent',
      });

      loader.present();

    this.salonService
      .saveSalon(salon)
      .pipe(
        switchMap((salon) => {
          this.userService.setSalon(salon);
          return this.stylistService.saveStylist(this.stylist);
        })
      )
      .subscribe({
        next: (result) => {
          loader.dismiss().then(() => {
            this.savingInProgress = false;
            this.submitted = false;
            this.stylistService.updateStylist(this.stylist);
            // if the stylist being updated is the same as the logged in stylist, update the user details
            if (this.stylist.getID() === this.userService.getUser().getID()) {
              this.userService.setUser(this.stylist);
            }
            this.toastService.presentSimpleToast(
              `Your booking settings have been successfully updated.`,
              3000
            );
            //this.navCtrl.pop();
            this.router.navigateByUrl('/settings');
          });
        },
        error: (e) => {
          loader.dismiss().then(() => {
            this.savingInProgress = false;
            this.alertService.presentErrorAlert();
          });
        },
      });
  }

  public onBack() {
    this.router.navigateByUrl('/booking-settings');
  }
}
